// Custom Fields
// @ts-ignore
import NumberCustomField from './custom/number/number';
// @ts-ignore
import StringCustomField from './custom/string/string';
// @ts-ignore
import DateCustomField from './custom/date/date';
// @ts-ignore
import CurrencyCustomField from './custom/currency/currency';
// @ts-ignore
import PercentageCustomField from './custom/percentage/percentage';
// @ts-ignore
import BooleanCustomField from './custom/boolean/boolean';
// @ts-ignore
import ListCustomField from './custom/list/list';
// @ts-ignore
import ListMultiCustomField from './custom/list-multi/list-multi';
// @ts-ignore
import RatingCustomField from './custom/rating/rating';
// @ts-ignore
import EmailCustomField from './custom/email/email';
// @ts-ignore
import PhoneCustomField from './custom/phone/phone';
// @ts-ignore
import UrlCustomField from './custom/url/url';
// @ts-ignore
import UserCustomField from './custom/user/user';
// @ts-ignore
import TextCustomField from './custom/text/text';
// @ts-ignore
import RAGCustomField from './custom/rag/rag';
// @ts-ignore
import FormulaCustomField from './custom/formula/formula';
// @ts-ignore
import UsersCustomField from "./custom/users/users";
// @ts-ignore
import ColorCustomField from "./custom/color/color"

import CUSTOM_FIELDS_V1 from "../gd/const/fields/custom-fields-v1";
import FieldReaction from "../fields3/generic/reaction/reaction";
import {FieldType} from "../fields3/field-type";
import {SessionCustomField} from "../gd-model/custom-field/gd-custom-field";
import FieldVoting from "../fields3/generic/voting/voting";
import FieldTimeOfDay from "../fields3/generic/datetime/time-of-day/time-of-day";
import FieldDatetime from "../fields3/generic/datetime/date-time/date-time";
import FieldToggle from "../fields3/generic/boolean/toggle/toggle";
import FieldAddress from "../fields3/generic/address/address";
import FieldAttachment from "../fields3/generic/attachment/attachment";

const debug = "getTaskCustomFieldByType"
// const debug = false


// return FIELD 1 OR field 3
export function getTaskCustomFieldByType(type : number, sessionCustomField?:SessionCustomField) {

    switch (type) {
        case gd.const.customFields.type.NUMBER:         return new NumberCustomField(sessionCustomField);
        case gd.const.customFields.type.STRING:         return new StringCustomField(sessionCustomField);
        case gd.const.customFields.type.DATE:           return new DateCustomField(sessionCustomField);
        case gd.const.customFields.type.CURRENCY:       return new CurrencyCustomField(sessionCustomField);
        case gd.const.customFields.type.PERCENTAGE:     return new PercentageCustomField(sessionCustomField);
        case gd.const.customFields.type.BOOLEAN:        return new BooleanCustomField(sessionCustomField);
        case gd.const.customFields.type.LIST:           return new ListCustomField(sessionCustomField);
        case gd.const.customFields.type.LIST_MULTI:     return new ListMultiCustomField(sessionCustomField);
        case gd.const.customFields.type.RATING:         return new RatingCustomField(sessionCustomField);
        case gd.const.customFields.type.EMAIL:          return new EmailCustomField(sessionCustomField);
        case gd.const.customFields.type.PHONE:          return new PhoneCustomField(sessionCustomField);
        case gd.const.customFields.type.URL:            return new UrlCustomField(sessionCustomField);
        case gd.const.customFields.type.USER:           return new UserCustomField(sessionCustomField);
        case gd.const.customFields.type.USERS:          return new UsersCustomField(sessionCustomField);
        case gd.const.customFields.type.TEXT:           return new TextCustomField(sessionCustomField);
        case gd.const.customFields.type.RAG:            return new RAGCustomField(sessionCustomField);
        case gd.const.customFields.type.FORMULA:        return new FormulaCustomField(sessionCustomField);
        case gd.const.customFields.type.COLOR:          return new ColorCustomField(sessionCustomField)


        case CUSTOM_FIELDS_V1.type.REACTION:

            const fieldReaction : FieldReaction =  new FieldReaction({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.REACTION,
                label       : sessionCustomField ? sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess    : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldReaction.isNewField = true
            return fieldReaction

        case CUSTOM_FIELDS_V1.type.VOTING:

            const fieldVoting : FieldVoting =  new FieldVoting({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.VOTING,
                label       : sessionCustomField ? sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldVoting.isNewField = true
            return fieldVoting

        case CUSTOM_FIELDS_V1.type.ATTACHMENT:

            const fieldAttachment : FieldAttachment =  new FieldAttachment({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.ATTACHMENT,
                label       : sessionCustomField ?  sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldAttachment.isNewField = true
            return fieldAttachment


        case CUSTOM_FIELDS_V1.type.TIME_OF_DAY:

            const fieldTimeOfDay : FieldTimeOfDay =  new FieldTimeOfDay({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.TIME_OF_DAY,
                label       : sessionCustomField ? sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldTimeOfDay.isNewField = true
            return fieldTimeOfDay

        case CUSTOM_FIELDS_V1.type.DATE_AND_TIME:

            const fieldDateAndTime : FieldDatetime =  new FieldDatetime({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.DATE_AND_TIME,
                label       : sessionCustomField ? sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldDateAndTime.isNewField = true
            return fieldDateAndTime

        case CUSTOM_FIELDS_V1.type.TOGGLE:

            const fieldToggle : FieldToggle =  new FieldToggle({
                fieldId       : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type          : FieldType.TOGGLE,
                label         : sessionCustomField ? sessionCustomField.name : '',
                fieldParams   : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess   : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldToggle.isNewField = true
            return fieldToggle



        case CUSTOM_FIELDS_V1.type.ADDRESS:

            const fieldAddress : FieldAddress =  new FieldAddress({
                fieldId     : sessionCustomField?sessionCustomField.id : 'temp-ID',
                type        : FieldType.ADDRESS,
                label       : sessionCustomField ? sessionCustomField.name : '',
                fieldParams : sessionCustomField ?  sessionCustomField.params : null,
                fieldAccess : sessionCustomField ?  sessionCustomField.access : undefined,
            })
            fieldAddress.isNewField = true
            return fieldAddress

        default:
            console.warn(debug, 'Warning #FF03: unknown custom field type (' + type + ')');
            return false;
    }
}


export function getTaskCustomFieldById(customFieldId:ID) : any {

    const sessionCustomField : any = gd.session.customFields.get(customFieldId)

    if (!sessionCustomField) {
        console.error("ERROR #Ddkdshjsa903 no CF FOUND")
        return
    }

    switch (sessionCustomField.type) {
        case gd.const.customFields.type.NUMBER:         return new NumberCustomField(sessionCustomField);
        case gd.const.customFields.type.STRING:         return new StringCustomField(sessionCustomField);
        case gd.const.customFields.type.DATE:           return new DateCustomField(sessionCustomField);
        case gd.const.customFields.type.CURRENCY:       return new CurrencyCustomField(sessionCustomField);
        case gd.const.customFields.type.PERCENTAGE:     return new PercentageCustomField(sessionCustomField);
        case gd.const.customFields.type.BOOLEAN:        return new BooleanCustomField(sessionCustomField);
        case gd.const.customFields.type.LIST:           return new ListCustomField(sessionCustomField);
        case gd.const.customFields.type.LIST_MULTI:     return new ListMultiCustomField(sessionCustomField);
        case gd.const.customFields.type.RATING:         return new RatingCustomField(sessionCustomField);
        case gd.const.customFields.type.EMAIL:          return new EmailCustomField(sessionCustomField);
        case gd.const.customFields.type.PHONE:          return new PhoneCustomField(sessionCustomField);
        case gd.const.customFields.type.URL:            return new UrlCustomField(sessionCustomField);
        case gd.const.customFields.type.USER:           return new UserCustomField(sessionCustomField);
        case gd.const.customFields.type.USERS:          return new UsersCustomField(sessionCustomField);
        case gd.const.customFields.type.TEXT:           return new TextCustomField(sessionCustomField);
        case gd.const.customFields.type.RAG:            return new RAGCustomField(sessionCustomField);
        case gd.const.customFields.type.FORMULA:        return new FormulaCustomField(sessionCustomField);
        case gd.const.customFields.type.COLOR:          return new ColorCustomField(sessionCustomField)


        case CUSTOM_FIELDS_V1.type.REACTION:

            return new FieldReaction({
                fieldId : sessionCustomField.id,
                type    : FieldType.REACTION
            })

        case CUSTOM_FIELDS_V1.type.VOTING:

            return new FieldVoting({
                fieldId : sessionCustomField.id,
                type    : FieldType.VOTING
            })

        case CUSTOM_FIELDS_V1.type.ATTACHMENT:

            return new FieldAttachment({
                fieldId : sessionCustomField.id,
                type    : FieldType.ATTACHMENT
            })

        case CUSTOM_FIELDS_V1.type.TIME_OF_DAY:

            return new FieldTimeOfDay({
                fieldId : sessionCustomField.id,
                type    : FieldType.TIME_OF_DAY
            })

        case CUSTOM_FIELDS_V1.type.DATE_AND_TIME:

            return new FieldDatetime({
                fieldId : sessionCustomField.id,
                type    : FieldType.DATE_AND_TIME
            })

        case CUSTOM_FIELDS_V1.type.TOGGLE:

            return new FieldToggle({
                fieldId : sessionCustomField.id,
                type    : FieldType.TOGGLE
            })

        case CUSTOM_FIELDS_V1.type.ADDRESS:

            return new FieldAddress({
                fieldId : sessionCustomField.id,
                type    : FieldType.ADDRESS
            })

        default:
            console.warn(debug, 'Warning #FF02: unknown custom field type (' + sessionCustomField.type + ')');
            return false;
    }


}
